module.exports = __webpack_public_path__ + "static/media/cnn.a8b0d15f.svg";